/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_appsync_graphqlEndpoint": "https://2vop7wr4erdkxn2ilg2hzmw7vi.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-6x2y5zsfmfbqdkeilsxtwwim3a",
    "aws_cognito_identity_pool_id": "eu-north-1:6776b3c3-e6ff-4025-9651-4ad94e7eb98e",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_mPxNhvSFX",
    "aws_user_pools_web_client_id": "78jfrfhpded6meevllpfmo73mo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-north-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "property-develop",
            "region": "eu-north-1"
        }
    ]
};


export default awsmobile;
